import { LegalPage } from "@/pages/legal/LegalPage";
import { site } from "@/config/site";

// Modèle à faire relire par un conseil juridique avant publication.
const sections = [
  { title: "Objet", content: [`Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les conditions d'accès et d'utilisation du site internet <strong>${site.domain}</strong> (ci-après « le Site »), édité par ${site.name}.`] },
  { title: "Acceptation", content: ["L'accès et l'utilisation du Site valent acceptation pleine et entière des présentes CGU. L'utilisateur qui n'accepte pas ces conditions est invité à ne pas utiliser le Site."] },
  {
    title: "Accès au site",
    content: [
      `Le Site est accessible gratuitement, 24 heures sur 24 et 7 jours sur 7, sauf interruption programmée ou non pour des besoins de maintenance ou en cas de force majeure. ${site.name} ne peut garantir une disponibilité absolue du Site et décline toute responsabilité en cas d'indisponibilité, de dysfonctionnement ou d'interruption, quelle qu'en soit la cause.`,
      "Les frais d'accès et d'utilisation du réseau de télécommunication sont à la charge de l'utilisateur.",
    ],
  },
  {
    title: "Contenu du site",
    content: [
      `Les informations présentées sur le Site ont un caractère informatif et non contractuel. Elles ne constituent ni une offre ferme, ni un engagement de ${site.name}. Seuls les devis acceptés et les Conditions Générales de Vente ont valeur contractuelle.`,
      `Les informations relatives aux services sont susceptibles d'évoluer à tout moment. ${site.name} s'efforce d'assurer l'exactitude des informations diffusées mais ne saurait garantir leur exhaustivité ou leur actualité.`,
    ],
  },
  {
    title: "Utilisation autorisée",
    content: [
      "L'utilisateur s'engage à utiliser le Site dans le cadre d'un usage personnel ou professionnel légitime, conformément aux présentes CGU et à la réglementation en vigueur.",
      { ul: [
        "toute tentative d'atteinte à la sécurité ou à l'intégrité du Site ou de ses systèmes d'information ;",
        "toute extraction massive, automatisée ou systématique de données (scraping) ;",
        "tout usage frauduleux, abusif ou automatisé des formulaires de contact et de devis ;",
        "toute diffusion de contenus illicites, diffamatoires ou portant atteinte aux droits de tiers.",
      ] },
      "Sont notamment interdits les comportements listés ci-dessus. Toute violation pourra donner lieu à des poursuites.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [`L'ensemble des éléments du Site (textes, images, logos, graphismes, structure, code) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de ${site.name} ou de ses ayants droit. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable est interdite. Voir également les <a href="/mentions-legales">Mentions légales</a>.`],
  },
  {
    title: "Liens hypertextes",
    content: [`Le Site peut contenir des liens vers des sites tiers. ${site.name} n'exerce aucun contrôle sur leur contenu et n'assume aucune responsabilité quant à ces sites, à leur disponibilité, à leurs pratiques en matière de données personnelles ou aux dommages pouvant résulter de leur consultation.`],
  },
  { title: "Données personnelles et cookies", content: [`Les traitements de données personnelles et l'utilisation de cookies sont décrits dans la <a href="/politique-de-confidentialite">Politique de confidentialité</a>.`] },
  {
    title: "Responsabilité",
    content: [
      `${site.name} met en œuvre les moyens raisonnables pour assurer le bon fonctionnement et la sécurité du Site, sans obligation de résultat. L'utilisateur reconnaît utiliser le Site sous sa responsabilité exclusive.`,
      `${site.name} ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du Site, de l'impossibilité d'y accéder, de la présence de virus ou de l'utilisation d'informations issues du Site.`,
    ],
  },
  { title: "Modification des CGU", content: [`${site.name} se réserve le droit de modifier unilatéralement les présentes CGU à tout moment. La version applicable est celle en ligne à la date de consultation du Site ; la date de dernière mise à jour est affichée en haut de la page.`] },
  { title: "Droit applicable et juridiction compétente", content: ["Les présentes CGU sont régies par le droit français. À défaut de résolution amiable, tout litige relatif à leur interprétation ou à leur exécution relèvera des tribunaux compétents de Bobigny, sous réserve des règles d'ordre public."] },
];

export default function CGU() {
  return (
    <LegalPage
      title="Conditions Générales d'Utilisation | MINES DE PARIS"
      description="Conditions Générales d'Utilisation du site minesdeparis.world : accès, contenu informatif, utilisation autorisée, propriété intellectuelle, responsabilité et droit applicable."
      path="/conditions-generales-utilisation"
      crumb="Conditions Générales d'Utilisation"
      intro="Conditions d'accès et d'utilisation du site minesdeparis.world."
      sections={sections}
    />
  );
}
